import { createSelector } from 'reselect'
import orgInactiveNotificationsEntity from './entity'

orgInactiveNotificationsEntity.addSelector('getInactiveNotificationsPeriod', selectors =>
  createSelector(selectors.get, entity => entity.get('inactiveNotificationsPeriod'))
)

orgInactiveNotificationsEntity.addSelector('getShowGetAllLoader', selectors =>
  createSelector(selectors.getSize, selectors.getPendingGetAll, (size, pending) => !!(size === 0 && pending))
)

orgInactiveNotificationsEntity.addSelector('getBeforeCreateId', selectors =>
  createSelector(selectors.get, entity => entity.get('beforeCreateId'))
)

orgInactiveNotificationsEntity.addSelector('getBeforeCreatePresenter', selectors =>
  createSelector(
    selectors.getAll,
    selectors.getBeforeCreateId,
    (all, id) => (typeof id === 'number' && all.get(id.toString())) || null
  )
)

orgInactiveNotificationsEntity.addSelector('getBeforeCreateOrder', selectors =>
  createSelector(selectors.getBeforeCreatePresenter, presenter => {
    if ((presenter && presenter.get && typeof presenter.get('order')) === 'number') {
      return presenter.get('order')
    }
    return null
  })
)
orgInactiveNotificationsEntity.addSelector('getIdToDelete', selectors =>
  createSelector(selectors.get, entity => entity.get('idToDelete'))
)

orgInactiveNotificationsEntity.addSelector('getListForUpdateOrder', selectors =>
  createSelector(selectors.getSortedList, list => list.map(el => ({ id: el.get('id'), order: el.get('order') })))
)

export default orgInactiveNotificationsEntity.getSelectors()
